// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import IconDropdownDown from "@tps/XDL/Icons//IconDropdownDown";
import IconDropdownUp from "@tps/XDL/Icons//IconDropdownUp";
import { xBaseTheme } from "@tps/XDL/types";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            variant: "body",
            forwardAs: "span",
            weight: "bold",
            color: "text.main",
            size: 12,
            lineHeight: "17px",
        },
        toggleIconProps: {
            color: "common.ui5",
            src: IconDropdownUp,
            size: 8,
        },
        expandIconProps: {
            src: IconDropdownDown,
        },
        headerProps: {
            css: css`
                background: ${color("common.background")};

                button {
                    padding: 9px;
                    border-style: solid;
                    border-width: 1px;
                    border-color: ${color("common.border")};
                    border-bottom-color: transparent;
                    background: ${color("common.background")};
                }

                &&& button,
                &&& ${/* sc-selector */ AccordionSectionPanel} + & button {
                    &:focus {
                        border-width: 1px;
                        border-color: ${color("common.border")};
                        border-bottom-color: transparent;
                        outline-width: 0;
                        padding: 9px;
                    }
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        &&& button,
                        &&& button:focus,
                        ${AccordionSectionPanel} + & button:focus {
                            border-bottom-color: ${color("common.border")};
                        }
                    `}
            `,
        },
        panelProps: {
            css: css`
                padding: 0 9px 9px;
            `,
        },
    },
} as xBaseTheme["accordion"];
